<!--
  File name: DataBreachForm.vue
  Program Description:
    - This component handles the Personal Data Breach Notification Form details.

-->

<!-- eslint-disable vue/no-lone-template -->
<template>
  <v-container>
    <v-row
      align-self="start"
      justify="center"
    >
      <v-col>
        <v-card
          :key="operation"
          class="transparent-bg"
          tile
          elevation="0"
        >
          <v-card-title class="pl-0 pb-0">
            <h2>
              <b>Personal Data Breach Notification Form</b>
            </h2>
            <StatusChip
              v-if="showHeaderStatus"
              :status="formItem.status.value"
              :is-active="formItem._status === 'active'"
              class="ml-3"
            />
            <v-spacer />
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-stepper
          v-if="tabs"
          v-model="activeTab"
          editable
          class="pb-0 transparent-bg"
          elevation="0"
        >
          <v-stepper-header
            class="ma-0"
          >
            <template
              v-for="(header, index) in tabs"
            >
              <v-stepper-step
                :key="header.index"
                class="stepper step-number"
                :step="index+1"
                editable
              >
                <span
                  class="headerLabel"
                >
                  {{ header.name }}
                </span>
              </v-stepper-step>
              <v-divider
                v-if="index !== (tabs.length - 1 ) && !(index === 3 && (projectStatus === 'inDrafts' || projectStatus === ''))"
                :key="`divider-${index}`"
                class="mx-1"
              />
            </template>
          </v-stepper-header>
        </v-stepper>
      </v-col>
    </v-row>
    <v-row v-if="showNote">
      <v-col class="py-1 px-9">
        <v-card-subtitle
          class="text-subtitle-1 font-weight-bold"
          style="color: #162b54"
        >
          Always save your work as draft in case of connection interruption.
        </v-card-subtitle>
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col
        class="d-flex justify-end pa-0 mr-3"
      >
        <v-btn
          v-if="!isPic && operation === 'view'"
          id="view-assign-btn"
          :loading="loading"
          color="primary"
          text
          @click="showAssignModal = true"
        >
          <v-icon class="mr-2">
            mdi-account-plus
          </v-icon>
          Assigned Users
        </v-btn>
        <v-btn
          v-if="!isPic && operation === 'view'"
          id="activity-logs-btn"
          :loading="loading"
          color="primary"
          class="mr-1"
          text
          @click="showLogs"
        >
          <v-icon class="mr-2">
            mdi-history
          </v-icon>
          Activity Logs
        </v-btn>
        <v-btn
          v-if="
            showLabel(`canViewAllPbnef`) &&
              formItem.withRequest === 'Yes' &&
              ((formItem.assignedTo && formItem.assignedTo.evaluator.fullName && isPBNEF) || canPICView) &&
              !canChange
          "
          id="pbnef-btn"
          color="primary"
          @click="$router.push({
            name: 'PBNEFLanding',
            params: {
              dataTab,
              dbn: id
            }
          })"
        >
          {{ getLabel(`canViewAllPbnef`, 'PBNEF') }}
        </v-btn>
        <!-- FBNER -->
        <v-btn
          v-if="!isPic && showLabel(`canViewAllFbner`) && operation === 'view' && isFBNER"
          id="fbner-btn"
          color="primary"
          class="ml-1"
          @click="goToFbner"
        >
          {{ getLabel(`canViewAllFbner`, 'FBNER') }}
        </v-btn>
        <!-- HIDE EXPORT PDBNF -->
        <!-- <v-btn
          v-if="
            showLabel(`canViewAllPbnef`) &&
              (formItem.withRequest === 'Yes' &&
                (formItem.assignedTo && formItem.assignedTo.evaluator.fullName) &&
                isPBNEF) ||
              canPICView
          "
          id="pbnef-btn"
          color="primary"
          @click="generatePDF"
        >
          {{ getLabel(`canViewAllPbnef`, 'Export PDBNF') }}
        </v-btn> -->
      </v-col>
    </v-row>
    <v-row
      align-self="start"
      justify="center"
    >
      <v-col class="mb-0 pb-0">
        <v-card
          :key="operation"
          tile
          elevation="0"
          outlined
        >
          <v-card-title class="pt-2 pb-2">
            <v-btn
              v-if="(readOnly && !loading)"
              id="back-btn"
              color="grey darken-1"
              text
              @click="$router.push(backRoute)"
            >
              <v-icon>mdi-arrow-left-thin</v-icon> Back to PDBNF Lists
            </v-btn>
            <template v-if="isPdbnfValid">
              <v-btn
                v-if="!readOnly && !loading && operation !== 'create' && !canChangeRequest"
                id="cancel-edit-btn"
                color="red darken-1"
                text
                @click="operation !== 'view' ? confirmCancelEdit() : readOnly = true, view() "
              >
                Cancel
              </v-btn>
              <v-spacer />
              <template>
                <v-btn
                  v-for="(item) in formActions"
                  v-show="!item.show || item.show(formItem)"
                  :key="item.fn"
                  v-bind="item.props"
                  @click="run(item.fn)"
                >
                  {{ item.label }}
                </v-btn>
                <v-btn
                  v-if="readOnly && showLabel(`canEvaluatePdbnf`) && !viewCondition && actionTabs && !loading && canUserEvaluate && isAssignee"
                  id="start-evaluate-btn"
                  class="mr-4"
                  color="primary"
                  type="button"
                  small
                  :loading="loading"
                  @click="operation !== 'update' ? $router.replace({ params: { operation: 'update', tab: activeTab } }) : readOnly = false"
                >
                  <v-icon>
                    mdi-file
                  </v-icon> {{ getLabel(`canEvaluatePdbnf`, 'Evaluate') }}
                </v-btn>
                <v-btn
                  v-if="!readOnly && showLabel(`canEvaluatePdbnf`) && !viewCondition && actionTabs && !loading && canUserEvaluate"
                  id="evaluate-btn"
                  class="mr-4"
                  color="primary"
                  type="button"
                  :disabled="!forSubmission"
                  small
                  :loading="loading"
                  @click="confirmDialog(false, 'evaluate')"
                >
                  {{ getLabel(`canEvaluatePdbnf`, 'Submit for Initial Review') }}
                </v-btn>
                <v-btn
                  v-if="readOnly && !viewCondition && actionTabs && !loading && canUserReview && isAssignee"
                  id="start-review-btn"
                  class="mr-4"
                  color="primary"
                  type="button"
                  small
                  :loading="loading"
                  @click="operation !== 'update' ? $router.replace({ params: { operation: 'update', tab: activeTab } }) : readOnly = false"
                >
                  <v-icon>
                    mdi-file-document
                  </v-icon> Review
                </v-btn>
                <v-btn
                  v-if="!readOnly && !viewCondition && actionTabs && !loading && canUserReview"
                  id="review-btn"
                  class="mr-4"
                  color="primary"
                  type="button"
                  :disabled="!forSubmission"
                  small
                  :loading="loading"
                  @click="confirmDialog(false, 'review')"
                >
                  Submit for {{ status === 'Initial Review' ? 'Final Review' : 'Initial Order' }}
                </v-btn>
                <!-- HIDE CHANGE OF REQUEST -->
                <v-btn
                  v-if="readOnly && showLabel(`canPatch${roleName}`) && !viewCondition && actionTabs && !loading && canChangeRequest"
                  id="edit-btn"
                  color="primary"
                  class="mr-1"
                  text
                  type="button"
                  :loading="loading"
                  @click="operation !== 'change' ? $router.replace({ params: { operation: 'change', tab: activeTab } }) : readOnly = false"
                >
                  <v-icon
                    small
                    class="mr-1"
                  >
                    mdi-clock-time-four-outline
                  </v-icon>
                  {{ getLabel(`canPatch${roleName}`, 'Add a Request') }}
                </v-btn>
                <v-btn
                  v-if="readOnly && !viewCondition && actionTabs && !loading && canChangeRequest"
                  id="start-upload-btn"
                  class="mr-4"
                  color="primary"
                  type="button"
                  small
                  :loading="loading"
                  @click="operation !== 'update' ? $router.replace({ params: { operation: 'update', tab: activeTab } }) : readOnly = false"
                >
                  <v-icon>
                    mdi-upload
                  </v-icon> Upload Documents
                </v-btn>
                <v-btn
                  v-if="readOnly && showLabel(`canDelete${roleName}`) && !viewCondition && actionTabs && !loading && canUserDelete"
                  id="delete-btn"
                  color="red darken-1"
                  text
                  type="button"
                  :disabled="deleteDisable"
                  :loading="loading"
                  @click.stop="checkDelete"
                >
                  <v-icon
                    small
                    class="mr-2"
                  >
                    mdi-delete
                  </v-icon>
                  {{ getLabel(`canDelete${roleName}`, 'Delete') }}
                </v-btn>
                <v-btn
                  v-if="readOnly && showLabel(`canPatch${roleName}`) && !viewCondition && actionTabs && !loading && canUserEdit"
                  id="edit-btn"
                  color="primary"
                  type="button"
                  :loading="loading"
                  @click="operation !== 'update' ? $router.replace({ params: { operation: 'update', tab: activeTab } }) : readOnly = false"
                >
                  <v-icon
                    small
                    class="mr-2"
                  >
                    mdi-pencil
                  </v-icon>
                  {{ getLabel(`canPatch${roleName}`, 'Edit Draft') }}
                </v-btn>
                <v-btn
                  v-if="showLabel(`canPost${roleName}`) && !readOnly && !viewCondition && !loading && canUserEdit"
                  id="save-draft-btn"
                  color="primary"
                  text
                  type="button"
                  :loading="loading"
                  @click="confirmDialog(true, 'update')"
                >
                  {{ getLabel(`canPost${roleName}`, 'Save as Draft') }}
                </v-btn>
                <v-btn
                  v-if="!readOnly && !loading && operation === 'create'"
                  id="cancel-edit-btn"
                  color="red darken-1"
                  style="color:white"
                  class="mx-2"
                  @click="$router.push(backRoute)"
                >
                  Cancel
                </v-btn>
                <v-btn
                  v-if="showLabel(`canPost${roleName}`) && !readOnly && !viewCondition && !loading && canUserEdit"
                  id="submit-btn"
                  color="primary"
                  type="button"
                  :disabled="!forSubmission"
                  :loading="loading"
                  @click="showReminderModal"
                >
                  {{ getLabel(`canPost${roleName}`, 'Submit Form') }}
                </v-btn>
                <v-btn
                  v-if="showLabel(`canPost${roleName}`) && !readOnly && !viewCondition && !loading && canChangeRequest"
                  id="cancel-edit-btn"
                  color="red darken-1"
                  class="white--text mr-2"
                  type="button"
                  :loading="loading"
                  @click="operation !== 'view' ? confirmCancelEdit() : readOnly = true, view()"
                >
                  {{ getLabel(`canPost${roleName}`, 'Cancel') }}
                </v-btn>
                <v-btn
                  v-if="showLabel(`canPost${roleName}`) && !readOnly && !viewCondition && !loading && canChangeRequest && !canChange"
                  id="submit-documents-btn"
                  color="primary"
                  type="button"
                  :disabled="!forSubmission"
                  :loading="loading"
                  @click="confirmDialog(false, 'upload')"
                >
                  {{ getLabel(`canPost${roleName}`, 'Submit Documents') }}
                </v-btn>
                <!-- POST SHOW CAUSE ORDER -->
                <v-btn
                  v-if="showLabel(`canPostShowCause`) && canPostShowCause && readOnly && !loading && isAssignee"
                  id="post-show-cause-btn"
                  flat
                  class="white--text"
                  color="primary"
                  @click="showCauseDialog = true"
                >
                  <v-icon class="mr-2">
                    {{ 'mdi-gavel' }}
                  </v-icon>
                  {{ getLabel(`canPostShowCause`, 'Post Show Cause Order') }}
                </v-btn>
                <v-dialog
                  :value="canPostShowCause"
                  max-width="600px"
                  persistent
                >
                  <v-card
                    class="elevation-12 px-10 py-6 rounded-lg"
                    tile
                  >
                    <v-card-title class="pl-0">
                      <h3 class="primary--text font-weight-bold">
                        Show Cause Order
                      </h3>
                    </v-card-title>
                    <v-textarea
                      v-model="showCauseReason"
                      :rules="[v => !!v || 'Explanation is required.']"
                      class="required-field cursor"
                      label="Explanation for non-submission of required documents (compliance with show cause order)"
                      outlined
                      rows="5"
                    />
                    <v-card-actions class="pa-0">
                      <v-spacer />
                      <v-btn
                        text
                        @click="$router.push({ name: 'DataBreachTable'})"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        :disabled="!showCauseReason.length"
                        color="primary"
                        @click="confirmDialog(false, 'initiate')"
                      >
                        Submit
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-btn
                  v-if="showLabel(`canPost${roleName}`) && !readOnly && !viewCondition && !loading && canChangeRequest && canChange"
                  id="submit-documents-btn"
                  color="primary"
                  type="button"
                  :disabled="!canSubmitReq"
                  :loading="loading"
                  @click="confirmDialog(false, 'change')"
                >
                  {{ getLabel(`canPost${roleName}`, 'Resubmit Form') }}
                </v-btn>
              </template>
            </template>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      align-self="start"
      justify="center"
    >
      <v-col class="mt-0 pt-0">
        <v-card
          :key="operation"
          tile
          elevation="0"
          outlined
        >
          <v-card-text class="pt-0">
            <v-container>
              <v-row
                v-show="operation === 'view' && !isLastTab"
                class="my-4"
              >
                <v-col>
                  <span
                    class="d-block font-weight-bold"
                    :style="'color: #162b54;'"
                  >
                    PDBNF Status
                  </span>
                  <StatusChip
                    v-if="formItem.status"
                    :status="formItem.status.value"
                    :is-active="formItem._status === 'active'"
                  />
                </v-col>
                <v-spacer />
                <v-col
                  v-if="formItem.status && formItem.status.value !== 'Drafted'"
                  cols="4"
                  class="pa-0 mt-4"
                >
                  <v-text-field
                    id="dbnNumber"
                    class="d-block my-4"
                    :style="'color: #162b54;'"
                    label="DBN Number"
                    :value="formItem.dbnNumber"
                    length="50%"
                    dense
                    disabled
                  />
                </v-col>
                <v-spacer />
                <v-col>
                  <span
                    class="d-block font-weight-bold"
                    :style="'color: #162b54;'"
                  >
                    Status History
                  </span>
                  <v-btn
                    color="#d6b315"
                    class="white--text"
                    @click="viewHistory"
                  >
                    <v-dialog
                      v-model="dialog"
                      max-width="800px"
                    >
                      <v-card
                        class="elevation-12 px-5 pt-3 pb-11 rounded-lg"
                        tile
                      >
                        <v-card-title
                          class="title"
                        >
                          <h1 class="primary--text text-h5 font-weight-bold">
                            Status History
                          </h1>
                        </v-card-title>
                        <v-card-text>
                          <v-row
                            class="mt-1"
                          >
                            <v-col
                              :cols="isPic ? '6': '4'"
                            >
                              <v-card-text class="font-weight-black text-body-1 py-0 px-5">
                                Status
                              </v-card-text>
                            </v-col>
                            <v-col
                              :cols="isPic ? '6': '4'"
                              class="text-center"
                            >
                              <v-card-text class="font-weight-black text-body-1 py-0 px-5">
                                Date and Time
                              </v-card-text>
                            </v-col>
                            <v-col
                              v-if="!isPic"
                              cols="4"
                              class="text-center"
                            >
                              <v-card-text class="font-weight-black text-body-1 py-0 px-5">
                                Modified By
                              </v-card-text>
                            </v-col>
                          </v-row>
                          <v-row
                            v-for="object in formItem.statusHistory"
                            :key="object.id"
                          >
                            <v-col
                              :cols="isPic ? '6': '4'"
                              class="py-1 px-5"
                            >
                              <span class="font-weight-black">
                                {{ setStatusMessage(object.status) }}
                              </span>
                            </v-col>
                            <v-col
                              :cols="isPic ? '6': '4'"
                              class="py-1 px-5 text-center"
                            >
                              <span class="font-weight-black">
                                {{ toDateAndTime(object.date) }}
                              </span>
                            </v-col>
                            <v-col
                              v-if="!isPic"
                              cols="4"
                              class="py-1 px-5 text-center"
                            >
                              <span class="font-weight-black">
                                {{ object.modifiedBy }}
                              </span>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <v-icon class="mr-1">
                      mdi-eye
                    </v-icon>
                    View
                  </v-btn>
                </v-col>
              </v-row>
              <ProvideDetailsModal
                v-if="([1,3].includes(activeTab) && canUploadDoc) || isDetailsProvided"
                :active-tab="activeTab"
                :form-item="formItem"
                :disabled="disabledProvideDetails"
                :is-submitted="isDetailsProvided"
                @update="updatedForm => { $set(formItem, 'noInformation', updatedForm) }"
              />
              <v-tabs-items v-model="activeTabMinus">
                <v-tab-item
                  v-for="(tab, tabIndex) in currentForm"
                  :key="tabIndex"
                  :to="tab.route"
                >
                  <template v-if="tab.children">
                    <template v-for="(field, fIndex) in tab.children">
                      <div
                        v-if="field.is === 'generateNotifications'"
                        :key="fIndex"
                      >
                        <template v-for="(notif, nIndex) in notifMain">
                          <v-row :key="`${nIndex}-row-1`">
                            <v-col
                              class="pb-0 pl-4"
                              cols="auto"
                            >
                              <v-checkbox
                                v-if="formItem.notificationType[nIndex]"
                                :id="`checkbox-${notif.value}`"
                                v-model="formItem.notificationType[nIndex].checkbox"
                                :label="notif.value"
                                length="50%"
                                dense
                                :disabled="canEditNotifType || readOnly"
                                :outlined="!readOnly"
                                @click="(val) => {
                                  if (!val) {
                                    formItem.notificationType[nIndex].subtype = undefined
                                    formItem.notificationType[nIndex].remarks = ''
                                  }
                                }"
                              />
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="formItem.notificationType[nIndex] && formItem.notificationType[nIndex].checkbox"
                            :key="`${nIndex}-row-2`"
                            class="pt-0 mt-0 pl-4"
                          >
                            <v-col
                              v-if="notif.subtype.length > 0"
                              class="pb-0"
                              cols="3"
                            >
                              <v-autocomplete
                                :id="`subtype-${notif.value}`"
                                v-model="formItem.notificationType[nIndex].subtype"
                                :items="notif.subtype"
                                item-value="_id"
                                item-text="value"
                                class="required-field"
                                label="Select One"
                                dense
                                :disabled="canEditNotifType"
                                :outlined="!readOnly"
                                :error-messages="$v.formItem && $v.formItem.notificationType ? genericErrorObjectArrayFormItem('notificationType', nIndex, 'subtype', 'Selecting one') : ''"
                                @blur="$v.formItem.notificationType.$each[nIndex].subtype.$touch()"
                                @input="$v.formItem.notificationType.$each[nIndex].subtype.$touch()"
                              />
                            </v-col>
                            <v-col
                              class="pb-0"
                              :cols="notif.subtype.length > 0 ? 7 : 10"
                            >
                              <v-textarea
                                :id="`remarks-${notif.value}`"
                                v-model="formItem.notificationType[nIndex].remarks"
                                class="required-field mb-1 cursor"
                                label="Remarks"
                                dense
                                outlined
                                rows="1"
                                :disabled="canEditNotifType"
                                :readonly="canEditNotifType"
                                :error-messages="$v.formItem && $v.formItem.notificationType ? genericErrorObjectArrayFormItem('notificationType', nIndex, 'remarks', 'Remarks') : ''"
                                @blur="$v.formItem.notificationType.$each[nIndex].remarks.$touch()"
                                @input="$v.formItem.notificationType.$each[nIndex].remarks.$touch()"
                              >
                                <template slot="append-outer">
                                  <v-tooltip
                                    v-if="setTooltip(notif.value)"
                                    max-width="400"
                                    right
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        color="gray"
                                        depressed
                                        v-bind="attrs"
                                        style="cursor: default"
                                        v-on="on"
                                      >
                                        mdi-information
                                      </v-icon>
                                    </template>
                                    <span>{{ setTooltip(notif.value) }}</span>
                                  </v-tooltip>
                                </template>
                              </v-textarea>
                            </v-col>
                          </v-row>
                        </template>
                      </div>
                      <component
                        :is="field.is"
                        v-else
                        v-show="field.hasOwnProperty('vShow') ? field['vShow'] : true"
                        :key="fIndex"
                        v-bind="field.vBind"
                      >
                        <template v-if="field.children">
                          <component
                            :is="child.is"
                            v-for="(child, cIndex) in field.children"
                            v-show="child.hasOwnProperty('vShow') ? child['vShow'] : true"
                            :key="cIndex"
                            v-bind="child.vBind"
                          >
                            <template v-if="child.children">
                              <template v-for="(gChild, gCIndex) in child.children">
                                <component
                                  :is="gChild.is"
                                  v-if="!gChild.header"
                                  v-show="gChild.hasOwnProperty('vShow') ? gChild['vShow'] : true"
                                  :key="gCIndex"
                                  v-model="formItem[gChild.formKey]"
                                  v-bind="gChild.vBind"
                                  :error-messages="gChild.hasOwnProperty('formKey') && formValidations && formValidations[gChild.formKey] ? genericError(`formItem.${gChild.formKey}`, gChild.vBind.label ? gChild.vBind.label : gChild.vBind.validationLabel): []"
                                  v-on="gChild.hasOwnProperty('formKey') ? gChild.vOn : null"
                                >
                                  <template
                                    v-if="gChild.formKey === 'dataSubjects' || gChild.formKey === 'typeOfRequest'"
                                    #selection="{ item, index }"
                                  >
                                    <v-chip
                                      v-if="gChild.formKey === 'dataSubjects' "
                                      color="#F0ECEC"
                                      style="color: #181C6C"
                                    >
                                      {{ item }}
                                    </v-chip>
                                    <span
                                      v-else
                                      class="mt-1 mr-1"
                                    >
                                      {{ getTypeOfRequestValue(item, index, formItem.typeOfRequest) }}
                                    </span>
                                  </template>
                                  <template v-if="gChild.is === 'v-btn'">
                                    <v-icon class="mr-2">
                                      {{ gChild.icon }}
                                    </v-icon>
                                    {{ gChild.btnLabel }}
                                  </template>
                                  <template
                                    v-if="gChild.hasOwnProperty('formKey') && gChild.formKey === 'typeOfRequest'"
                                    v-slot:[`item`]="{ item }"
                                  >
                                    <v-checkbox
                                      :disabled="item.disabled"
                                      :input-value="formItem.typeOfRequest && formItem.typeOfRequest.includes(item.label)"
                                      :label="formattedLabelTypeOfRequest(item.label)"
                                      class="ma-0 mt-2"
                                      value
                                    />
                                    <v-spacer />
                                    <v-tooltip
                                      v-if="setTooltip(item.label)"
                                      max-width="400"
                                      right
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                          color="gray"
                                          depressed
                                          v-bind="attrs"
                                          style="cursor: default"
                                          v-on="on"
                                        >
                                          mdi-information
                                        </v-icon>
                                      </template>
                                      <span>{{ setTooltip(item.label) }}</span>
                                    </v-tooltip>
                                  </template>
                                  <template
                                    v-if="gChild.hasOwnProperty('formKey') && gChild.formKey === 'typeOfRequest'"
                                    #selection="{ item }"
                                  >
                                    <v-chip
                                      v-show="showSelectionTypeOfRequest(item)"
                                      small
                                    >
                                      {{ formattedSelectionTypeOfRequest(item.label) }}
                                    </v-chip>
                                  </template>
                                  <template
                                    v-if="gChild.info"
                                    slot="append"
                                  >
                                    <v-tooltip
                                      max-width="400"
                                      right
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                          color="gray"
                                          depressed
                                          v-bind="attrs"
                                          style="cursor: default"
                                          v-on="on"
                                        >
                                          mdi-information
                                        </v-icon>
                                      </template>
                                      <span>{{ gChild.info }}</span>
                                    </v-tooltip>
                                    <v-icon v-if="!(gChild.formKey === 'representative' || gChild.formKey === 'contactInfo')">
                                      mdi-menu-down
                                    </v-icon>
                                  </template>
                                </component>
                                <component
                                  :is="gChild.is"
                                  v-else
                                  :key="gCIndex"
                                  v-bind="gChild.vBind"
                                >
                                  {{ gChild.vText }}
                                  <v-tooltip
                                    v-if="gChild.info"
                                    max-width="400"
                                    right
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        class="ml-2"
                                        color="light-gray"
                                        depressed
                                        v-bind="attrs"
                                        style="cursor: default"
                                        v-on="on"
                                      >
                                        mdi-information
                                      </v-icon>
                                    </template>
                                    <span
                                      style="white-space: pre-line;"
                                      class="ma-0"
                                    >
                                      {{ gChild.info }}
                                    </span>
                                  </v-tooltip>
                                </component>
                              </template>
                            </template>
                          </component>
                        </template>
                      </component>
                    </template>
                  </template>
                </v-tab-item>
              </v-tabs-items>
              <v-row class="pr-4 pt-12 pb-4">
                <v-btn
                  v-if="activeTab !== 1"
                  id="prev-btn"
                  text
                  type="button"
                  :loading="loading"
                  @click="prevTab"
                >
                  <v-icon class="mr-1">
                    {{ 'mdi-arrow-left' }}
                  </v-icon> Back
                </v-btn>
                <v-spacer />
                <v-btn
                  v-if="showLabel(`canPost${roleName}`) && !readOnly && !viewCondition && !loading && canUserEdit"
                  id="save-draft-btn"
                  color="primary"
                  class="mx-1"
                  text
                  type="button"
                  :loading="loading"
                  @click="confirmDialog(true, 'update')"
                >
                  {{ getLabel(`canPost${roleName}`, 'Save as Draft') }}
                </v-btn>
                <v-btn
                  v-if="!readOnly && !loading && operation === 'create'"
                  id="cancel-edit-btn"
                  color="red darken-1"
                  style="color:white"
                  class="mr-2"
                  @click="$router.push(backRoute)"
                >
                  Cancel
                </v-btn>
                <v-btn
                  v-if="showLabel(`canPost${roleName}`) && !readOnly && !viewCondition && !loading && canUserEdit && forSubmission"
                  id="submit-btn"
                  color="primary"
                  class="mx-1"
                  type="button"
                  :loading="loading"
                  @click="showReminderModal"
                >
                  {{ getLabel(`canPost${roleName}`, 'Submit Form') }}
                </v-btn>
                <v-btn
                  v-if="!forSubmission"
                  id="next-btn"
                  class="white--text"
                  color="#d6b315"
                  :loading="loading"
                  @click="nextTab"
                >
                  Continue <v-icon class="mr-1">
                    {{ 'mdi-arrow-right' }}
                  </v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <AssignUserModal
      v-if="!isPic"
      v-model="showAssignModal"
      :is-priority="isPriority"
      :disabled="!canReAssign || !isPdbnfValid"
      :form-item="formItem"
      @assignUser="view()"
    />
    <PBNEFResultModal
      v-if="pbnefResultsPopUp"
      :items="formItem.pbnefRequest"
    />
    <template v-if="status !== 'create'">
      <v-dialog
        v-model="historyModal"
        width="40%"
      >
        <v-card class="px-11 py-11">
          <v-card-title
            class="pb-8 pl-0 font-weight-bold text-h5"
            style="color:#162b54;"
          >
            Status History
          </v-card-title>
          <v-row>
            <v-col>
              <h4>Status</h4>
            </v-col>
            <v-col>
              <h4>Date and Time</h4>
            </v-col>
            <v-col>
              <h4>Modified By</h4>
            </v-col>
          </v-row>
          <v-row
            v-for="(history,i) in formItem.statusHistory"
            :key="i"
          >
            <v-col class="py-1">
              {{ history.status }}
            </v-col>
            <v-col class="py-1">
              {{ convertDate(history.date) }}
            </v-col>
            <v-col class="py-1">
              {{ history.modifiedBy }}
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <SetDeadlineCard
        v-if="showLabel(`canPostShowCause`) && canPostShowCause && readOnly && !loading && isAssignee"
        ref="deadline"
        :form-item="formItem"
        @refresh="view"
      />
    </template>
    <v-btn
      fab
      fixed
      bottom
      right
      class="primary btn--fab"
      @click="scrollToTop()"
    >
      <v-icon
        color="#FFFFFF"
      >
        mdi-arrow-up
      </v-icon>
    </v-btn>
    <div style="display: none;">
      <component
        :is="'ExportPDBNF'"
        id="pdfContent"
        :data="exportData"
      />
    </div>
  </v-container>
</template>

<script>
import { format, differenceInCalendarDays, parseISO } from 'date-fns'
import crud from '@/utils/rest/crud'
import pdbnf from '@/utils/webapi/pdbnf'
import validationErrors from '../utils/validations/errors'
import { custom } from '@/utils/validations'
import { validationMixin } from 'vuelidate'
import flattenFields from '@/meta/mdTable/utils/flattenFields'
import { privilegeMixin } from 'session-plugin'
import { dateAndTimeCreated, capitalize, dataURLToFile, uploadNestedForm, convertObjId, addDaysToDate, toOrdinal } from '../utils/helpers'
import pbnef from '@/store/pbnef'
import reportsMixin from '@/mixins/reportsMixin'
import ExportPDBNF from '@/components/exports/ExportPDBNF'
import { socket } from '@/socket'
import { mapGetters } from 'vuex'
import SetDeadlineCard from '@/components/SetDeadlineCard'
import ProvideDetailsModal from '@/components/ProvideDetailsModal'
import AssignUserModal from '@/components/AssignUserModal'
import StatusChip from '@/components/StatusChip'
import PBNEFResultModal from '@/components/PBNEFResultModal'

export default {
  name: 'DataBreachForm',
  components: {
    ExportPDBNF,
    SetDeadlineCard,
    ProvideDetailsModal,
    AssignUserModal,
    StatusChip,
    PBNEFResultModal
  },
  mixins: [
    privilegeMixin,
    validationMixin,
    reportsMixin
  ],
  props: {
    name: {
      type: String,
      default: ''
    },
    mdTables: {
      type: Object,
      default: undefined
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: String,
      default: undefined
    }
  },
  data: () => ({
    loading: true,
    dialog: false,
    formItem: {
      notificationType: [],
      notification: '',
      dateOfNotification: '',
      generalCause: '',
      specificCause: '',
      implementation: '',
      enabled: {}
    },
    implemError: false,
    notifCheckbox: false,
    changeReqData: {},
    evaluator: '',
    reviewer: '',
    finalReviewer: '',
    showCauseReason: '',
    reviewers: [],
    recipients: [],
    showAssignModal: false,
    currentRecipient: '',
    assignedAdjudicator: '',
    assignedEnforcer: '',
    assignedInvestigator: '',
    isPriority: false,
    file: null,
    submittedFbner: false,
    readOnly: true,
    showCauseDialog: false,
    activeTab: 1,
    forSubmission: false,
    historyModal: false,
    fbnerId: '',
    notifications: [],
    status: 'create',
    objToFlat: [
      'howBreachOccurred',
      'chronology',
      'numberOfDataSubjects',
      'descriptionOrNature',
      'likelyConsequences',
      'dataProtectionOfficer',
      'sensitivePersonalInformation',
      'identityFraud',
      'measuresToAddress',
      'measuresToSecure',
      'actionsToMitigateHarm',
      'actionsToInformDataSubjects',
      'measuresToPreventRecurrence'
    ],
    fileFields: [
      'fullReport',
      'privacyImpactAssessment',
      'securityIncidentManagementPolicy',
      'operationsSecurity',
      'systemAcquisition',
      'accessControl',
      'communicationsSecurity',
      'physicalAndEnvironmentalSecurity',
      'assetManagement',
      'cryptography',
      'humanResourceSecurity',
      'compliance',
      'informationSecurityPolicy',
      'dataSubjectNotification',
      'delayInNotificationExplanation',
      'othersAttachment'
    ],
    dateFields: [
      'dateOfNotification',
      'dateOfOccurrence',
      'dateOfDiscovery',
      'dateOfEvaluation'
    ],
    exportData: null,
    sectorOpts: [],
    causeOpts: [],
    recordOpts: [],
    picUser: {}
  }),
  computed: {
    ...validationErrors,
    ...mapGetters('lookups', {
      profile: 'getCurrentUser'
    }),
    transparent () {
      return disabled => disabled && this.canChange ? 'color-transparent' : ''
    },
    module () {
      return this.$props.mdTables[this.name](this)
    },
    form () {
      return this.module.form
    },
    createReroute () {
      return this.form.createReroute
    },
    backRoute () {
      return this.form.backRoute
    },
    tabs () {
      return this.form.tabs[this.dataTab].filter(x => !x.removeIn || (x.removeIn && !x.removeIn.includes(this.operation)))
    },
    fields () {
      return this.form.fields
    },
    schema () {
      return this.form.schema[this.dataTab]
    },
    evaluateSchema () {
      return this.form.evaluateSchema
    },
    initialOrderSchema () {
      return this.form.initialOrderSchema
    },
    nestedSchema () {
      return this.form.nestedSchema && this.form.nestedSchema[this.dataTab]
    },
    dataTab () {
      return this.$route.params.dataTab
    },
    currentForm () {
      return this.fields[this.dataTab]
    },
    currentTab () {
      return this.currentForm.find(x => x.tab === this.activeTab)
    },
    formActions () {
      return this.currentTab ? this.currentTab.formActions : []
    },
    canEditNotifType () {
      return this.currentTab && this.currentTab.canEditNotifType ? this.currentTab.canEditNotifType : false
    },
    optionID () {
      return this.currentTab ? this.currentTab.optionID : undefined
    },
    optionName () {
      return this.currentTab ? this.currentTab.optionName : undefined
    },
    optionQuery () {
      return this.currentTab ? this.currentTab.optionQuery : undefined
    },
    optionNested () {
      return this.currentTab ? this.currentTab.optionNested : undefined
    },
    optionView () {
      return this.currentTab ? this.currentTab.optionView : undefined
    },
    populateFetch () {
      return this.currentTab ? this.currentTab.populate : undefined
    },
    optionAction () {
      return this.currentTab ? this.currentTab.optionAction : 'lookups/getOptions'
    },
    id () {
      return this.$route.params.id
    },
    operation () {
      return this.$route.params.operation
    },
    collection () {
      return crud(this.dataTab)
    },
    roleName () {
      return capitalize(this.dataTab)
    },
    flatFields () {
      return flattenFields(this.currentTab.children)
    },
    currentFields () {
      return this.flatFields.filter(x => x.formKey)
    },
    fieldKeys () {
      return this.currentFields.map(x => x.formKey)
    },
    showHeaderStatus () {
      return this.formItem.status && this.readOnly && !this.loading && this.status !== 'create'
    },
    defaultItem () {
      const ret = {}
      this.currentFields
        .forEach(x => {
          ret[x.fieldName || x.value] = x.defaultValue
          this.$set(this.formItem, x.key || x.columnHeader.value, x.defaultValue || '')
        })
      return ret
    },
    pbnefResultsPopUp () {
      if (!this.formItem.statusHistory) return false
      if (this.formItem.status.value === 'For Approval - PBNEF') return false
      const recentHistoryIndex = this.formItem.statusHistory.length - 2
      const history = this.formItem.statusHistory[`${recentHistoryIndex}`]
      const recentStatus = history && history.status
      const isPBNEFComplete = recentStatus === 'Final Review - PBNEF' || recentStatus === 'For Approval - PBNEF'
      const haveRequests = this.formItem.pbnefRequest && this.formItem.pbnefRequest.length
      return this.isPic && isPBNEFComplete && haveRequests && this.operation === 'view'
    },
    collectionLabel () {
      return this.currentTab.label
    },
    collectionHeader () {
      const header = `${this.capitalize(this.operation)} ${this.collectionLabel}`
      return this.module.allCapsHeader ? header.toUpperCase() : header
    },
    lookupState () {
      return this.$store.state.lookups[this.dataTab]
    },
    uploadQuery () {
      return this.form.uploadQuery
    },
    customItems () {
      return this.$store.state.lookups
    },
    watchFields () {
      return this.form.watchFields[this.dataTab]
    },
    objectId () {
      return this.form.convertToObjId && this.form.convertToObjId[this.dataTab]
    },
    formValidations () {
      return this.form.validations[this.dataTab]
    },
    startIndex () {
      return (this.form.startIndex && this.form.startIndex[this.dataTab]) || 0
    },
    saveIndex () {
      return this.form.saveIndex[this.dataTab]
    },
    tabLength () {
      return this.saveIndex || this.tabs.length
    },
    tabGrow () {
      return this.tabs.length < 3
    },
    actionTabs () {
      return this.checkAction(this.activeTab)
    },
    isLastTab () {
      return this.$data.activeTab === this.tabLength
    },
    userRole () {
      return (this.$s && this.$s.userRole)
    },
    isPic () {
      return this.userRole && this.$s.userRole.includes('pic')
    },
    isAssignor () {
      return this.userRole && this.$s.userRole.includes('assignor')
    },
    isPdbnfValid () {
      return this.formItem._status === 'active' || this.operation === 'create'
    },
    showNote () {
      return this.$s.userType === 'External' && (this.operation === 'create' || this.operation === 'update') && !this.formItem.submitted
    },
    canReAssign () {
      const assigned = this.formItem.assignedTo
      const alreadyAssigned = assigned && assigned.evaluator._id && assigned.firstPass._id && assigned.final._id
      return this.isAssignor && (alreadyAssigned || this.isPriority)
    },
    canSubmitReq () {
      return this.$data.activeTab === 2
    },
    deleteDisable () {
      return this.module.deleteDisable
    },
    viewCondition () {
      return this.viewOnly || this.form.viewOnly
    },
    activeTabMinus () {
      return this.activeTab - 1
    },
    notificationCrud () {
      return crud('notificationType')
    },
    dbnStatusCrud () {
      return crud('dbnStatus')
    },
    pdbnfCrud () {
      return crud('pdbnf')
    },
    notifMain () {
      return this.notifications
    },
    notifSub () {
      return this.notifications.filter(x => x.type === 'subtype')
    },
    notifMandatory () {
      return this.notifications.filter(x => x.mandatory === true)
    },
    allMandatory () {
      let value = true
      let subtype
      this.notifMandatory.forEach(notif => {
        subtype = notif.subtype.find(x => x.value === 'Yes')
        const obj = this.formItem.notificationType.find(x => x._id === notif._id)
        value = value && obj.checkbox && obj.subtype === subtype._id
      })
      return value
    },
    canChange () {
      return this.operation === 'change' && this.status === 'Initial Order'
    },
    canUserEdit () {
      if (this.userRole && this.userRole.includes('pic')) {
        return this.status === 'Drafted' || this.status === 'create'
      }
      return false
    },
    canUserEditField () {
      return objArr => {
        // feed from field, current status, userrole
        // objArr contains what USERROLE can edit and what STATUS they can edit it
        if (this.userRole) {
          const userRoles = this.userRole
          const temp = objArr.filter(x => userRoles.includes(x.userRole))
          return temp.some(x => x.status.includes(this.status))
        }
        return false
      }
    },
    canUserDelete () {
      if (this.userRole && this.userRole.includes('pic')) {
        return this.status === 'Drafted'
      }
      return false
    },
    isEvaluator () {
      return (this.userRole && this.userRole.includes('evaluator'))
    },
    canUserEvaluate () {
      if (this.userRole && this.userRole.includes('evaluator')) {
        return this.status === 'For Evaluation'
      }
      return false
    },
    isAssignee () {
      if (!this.formItem.status) return false
      const userID = this.$s.user
      const { evaluator, reviewer, finalReviewer } = this.formItem.assignedTo
      switch (this.formItem.status.value) {
        case 'For Evaluation':
          return this.evaluator === userID || (evaluator && evaluator._id === userID)
        case 'Initial Review':
          return this.reviewer === userID || (reviewer && reviewer._id === userID)
        case 'Final Review':
          return this.finalReviewer === userID || (finalReviewer && finalReviewer._id === userID)
        case 'Show Cause Order':
          return this.evaluator === userID || (evaluator && evaluator._id === userID)
      }
      return false
    },
    isPBNEF () {
      const userID = this.$s.user
      if (!this.formItem.assignedTo) return false

      const { evaluator, firstPass, final } = this.formItem.assignedTo
      const status = this.formItem.status.value
      const isEvaluator = evaluator && evaluator._id === userID
      const isFirstReviewer = firstPass && firstPass._id === userID
      const isFinalReviewer = final && final._id === userID
      const isRecipient = this.formItem.recipient && this.formItem.recipient.adjudication === userID
      if (status === 'For Evaluation - PBNEF') return isEvaluator
      else if (status === 'For Adjudication') return (this.userRole.includes('adjudicationRecipient') || isEvaluator || isFirstReviewer || isFinalReviewer)
      else if (status === 'Initial Review - PBNEF') return (isEvaluator || isFirstReviewer)
      else if (status === 'Final Review - PBNEF') return (isEvaluator || isFirstReviewer || isFinalReviewer || isRecipient)
      else if (status === 'For Approval - PBNEF') {
        return (isEvaluator || isFirstReviewer || isFinalReviewer || this.recipients.includes(this.$s.user)) || isRecipient
      } else {
        const values = Object.keys(this.formItem.assignedTo).map(assign => this.formItem.assignedTo[`${assign}`]._id === userID)
        return values.some(x => x) || isRecipient
      }
    },
    isFBNER () {
      const userID = this.$s.user
      const hideStatuses = [
        'Drafted',
        'Submitted',
        'For Evaluation',
        'Initial Review',
        'Final Review',
        'Initial Order',
        'For Evaluation - PBNEF',
        'Initial Review - PBNEF',
        'Final Review - PBNEF',
        'For Approval - PBNEF',
        'Show Cause Order',
        'For Approval - PBNEF'
      ]
      if (!this.formItem.assignedTo) return false
      const { evaluator, firstPass, final } = this.formItem.assignedTo
      const status = this.formItem.status.value
      const isEvaluator = evaluator && evaluator._id === userID
      const isFirstReviewer = firstPass && firstPass._id === userID
      const isFinalReviewer = final && final._id === userID
      const isAdjudicator = this.userRole.includes('adjudicationRecipient')
      const isInvestigator = this.assignedInvestigator === userID
      const isEnforcer = this.assignedEnforcer === userID
      if (status === 'For Evaluation - FBNER') return isEvaluator || this.isPic
      else if (status === 'Initial Review - FBNER') return (isEvaluator || isFirstReviewer) || this.isPic
      else if (status === 'Final Review - FBNER') return (isEvaluator || isFirstReviewer || isFinalReviewer) || this.isPic
      else if (status === 'For Investigation') {
        return (isEvaluator || isFirstReviewer || isFinalReviewer || isInvestigator) || this.isPic
      } else if (status === 'For Adjudication') {
        return (isEvaluator || isFirstReviewer || isFinalReviewer || isInvestigator || isAdjudicator) || this.isPic
      } else if (status === 'For Enforcement' || status === 'Closed') {
        return (isEvaluator || isFirstReviewer || isFinalReviewer || isInvestigator || isAdjudicator || isEnforcer) || this.isPic
      } else {
        if (hideStatuses.includes(status)) {
          return false
        }
        const values = Object.keys(this.formItem.assignedTo).map(assign => this.formItem.assignedTo[`${assign}`]._id === userID)
        return values.some(x => x)
      }
    },
    showSelectionTypeOfRequest () {
      return item => {
        if (!this.canChange) return true
        return !item.disabled
      }
    },
    formattedSelectionTypeOfRequest () {
      return (text, index) => {
        if (!text.includes('Request for extension')) return text
        if (this.canChange) return 'Request for extension'
        const numberOfRequest = text.split(' ')[0].replace(/[{()}]/g, '')
        if (isNaN(parseInt(numberOfRequest))) return text
        return toOrdinal(numberOfRequest) + ' Request for extension'
      }
    },
    formattedLabelTypeOfRequest () {
      return text => {
        if (text === 'Request for exemption') return `${text} to notify data subject`
        else if (text === 'Request for postponement') return `${text} (of data subject notification)`
        else if (text.includes('Request for extension')) {
          const externalLabel = 'Request for extension (of submission of full report and any other documents)'
          const internalLabel = `${text} (of submission of full report and any other documents)`
          return this.isPic ? externalLabel : internalLabel
        }
        return text
      }
    },
    typeOfReqItems () {
      const selectedTypeOfReq = this.changeReqData.typeOfRequest
      let usedExtensions = selectedTypeOfReq && selectedTypeOfReq.filter(item => item.includes('extension'))
      if (!usedExtensions) usedExtensions = []

      const items = []
      const types = [
        'Request for exemption',
        'Request for postponement',
        'Request for alternative means of notification'
      ]

      if (this.canChange || this.canUserEdit) usedExtensions.push('another extension')
      for (const index in usedExtensions) {
        const extension = `${index !== '0' ? `(${parseInt(index) + 1}) ` : ''}Request for extension`
        this.$set(this.changeReqData, 'availExtension', extension)
        types.splice(2 + parseInt(index), 0, extension)
      }

      for (const label of types) {
        const disabled = this.canChange && selectedTypeOfReq && selectedTypeOfReq.includes(label)
        items.push({ label, disabled })
      }
      return items
    },
    canUpdateRequest () {
      let canUpdate = false
      if (this.operation === 'create') {
        canUpdate = this.canUserEditField([{ userRole: 'pic', status: ['create'] }])
      } else if (this.operation === 'update') {
        canUpdate = this.canUserEditField([{ userRole: 'pic', status: ['Drafted'] }])
      } else if (this.operation === 'change') {
        canUpdate = this.canUserEditField([{ userRole: 'pic', status: ['Initial Order'] }])
      }
      return canUpdate
    },
    canUserReview () {
      if (this.userRole && this.userRole.includes('reviewer')) {
        const arr = ['Initial Review', 'Final Review']
        return arr.includes(this.status)
      }
      return false
    },
    isDetailsProvided () {
      return (this.formItem.noInformation && (Object.keys(this.formItem.noInformation).length > 0))
    },
    disabledProvideDetails () {
      return this.isDetailsProvided || !this.isPic || !this.canUploadDoc
    },
    canUploadDoc () {
      return this.status === 'Initial Order' && this.isPic
    },
    canChangeRequest () {
      if (this.userRole && this.userRole.includes('pic')) {
        return this.status === 'Initial Order'
      }
      return false
    },
    canPostShowCause () {
      return this.userRole.includes('pic') && this.status === 'Show Cause Order'
    },
    isDocumentSubmitted () {
      const isFbner = !!this.formItem.statusHistory.find(item => (item.status === 'For Evaluation - FBNER'))
      const attachmentExists = this.formItem.othersAttachmentFile.length > 0
      return isFbner && attachmentExists
    },
    canPICView () {
      let pastInitialOrder = false
      if (this.formItem.statusHistory) {
        const statusHistory = [...this.formItem.statusHistory]
        let latestPrevStatus = statusHistory.pop()

        while (latestPrevStatus.status !== 'Submitted' && latestPrevStatus.status !== 'Initial Order' && statusHistory.length) {
          latestPrevStatus = statusHistory.pop()
        }
        if (latestPrevStatus && latestPrevStatus.status === 'Initial Order') pastInitialOrder = true
      }

      return (this.picUser._id === this.$s.user) && pastInitialOrder
    }
  },
  watch: {
    activeTab: function () {
      this.$data.forSubmission = this.isLastTab
      if (!this.actionTabs) {
        this.readOnly = true
        this.view()
      }
    },
    readOnly: function () {
      this.$data.forSubmission = this.isLastTab
    },
    allMandatory: function (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        this.$set(this.formItem, 'notification', 'Mandatory')
      } else if (newVal === false && oldVal === true) {
        this.$set(this.formItem, 'notification', 'Voluntary')
      }
    },
    'formItem.dateOfDiscovery': function () {
      const { dateOfNotification, dateOfDiscovery } = this.formItem
      const diff = differenceInCalendarDays(parseISO(dateOfNotification), parseISO(dateOfDiscovery))
      if (diff > 3 && dateOfDiscovery) {
        this.formItem.timeliness = 'Delayed'
      } else {
        this.formItem.timeliness = 'Timely'
      }
    },
    '$v.formItem.implementation.$error': function (val) {
      this.implemError = val
    },
    '$v.formItem.notificationType.$error': function (val) {
      this.notifCheckbox = !!val
    },
    id () {
      this.$router.go()
    }
  },
  async created () {
    this.watchFields && this.watchFields.forEach((w) => {
      this.$watch(w.fieldName, w.function)
    })
    this.currentForm.forEach((currentTab) => {
      currentTab.watch && currentTab.watch.forEach((w) => {
        this.$watch(w.fieldName, w.function)
      })
    })

    await this.getNotificationsData()
    await this.getStatusList()
    await this.getSectors()
    await this.getCauses()
    await this.getRecords()
    if (this.isAssignor) await this.getPriority()
    this.$s.userRole.includes('adjudicationRecipient') && await this.getAdjudications()

    !this.optionID && this.customOptionFetch()
    if (this.operation === 'create') {
      this.formItem.dateOfNotification = `${format(new Date(), 'yyyy-MM-dd')}`
      this.readOnly = false
      this.status = 'create'
      await this.getUserData()
    } else {
      await this.view()
      if (this.operation === 'update') this.readOnly = false
      if (this.operation === 'change') this.readOnly = false
    }
    this.loading = false
    this.$store.dispatch('pbnef/reset')
  },
  beforeCreate () {
    if (!this.$store.hasModule('pbnef')) {
      this.$store.registerModule('pbnef', pbnef)
    }
  },
  beforeDestroy () {
    this.$store.dispatch('pbnef/reset')
  },
  beforeMount () {
    this.$route.params.tab && (this.$data.activeTab = this.$route.params.tab)
  },
  methods: {
    confirmLeave () {
      return window.confirm('Are you sure you want to cancel? All unsaved data will be lost.')
    },
    confirmStayInDirtyForm () {
      if (!this.$refs.dataBreachForm.readOnly) {
        return !this.confirmLeave()
      }
    },
    confirmCancelEdit () {
      if (this.confirmLeave()) {
        this.$router.replace({ params: { operation: 'view', tab: this.activeTab } })
      }
    },
    setStatusMessage (status) {
      let message
      switch (status) {
        case 'Drafted':
          message = 'PDBNF has been saved to drafts.'
          break
        case 'Submitted':
          message = 'PDBNF has been submitted.'
          break
        default:
          message = `PDBNF status changed to '${status}'.`
          break
      }
      return message
    },
    setTooltip (item) {
      let tooltip
      let field = item.toLowerCase()
      if (item.includes('extension')) field = 'request for extension'
      switch (field) {
        case 'involves spi or data that may enable identity fraud':
          tooltip = 'Provide examples such as but not limited to: data about the financial or economic situation of the data subject; usernames, passwords and other login data; biometric data; copies of identification documents, licenses or unique identifiers like Philhealth, SSS, GSIS, TIN number; or other similar information, which may be made the basis of decisions concerning the data subject, including the grant of rights or benefits.'
          break
        case 'involves spi/data that may enable identity fraud':
          tooltip = 'Provide examples such as but not limited to: data about the financial or economic situation of the data subject; usernames, passwords and other login data; biometric data; copies of identification documents, licenses or unique identifiers like Philhealth, SSS, GSIS, TIN number; or other similar information, which may be made the basis of decisions concerning the data subject, including the grant of rights or benefits.'
          break
        case 'acquired by an unauthorized person':
          tooltip = 'Provide brief description why there is a possiblity that personal data or sensitive personal data was acquired by unauthorized person.'
          break
        case 'likely to give rise to a real risk of serious harm to data subjects':
          tooltip = 'Provide brief explanation why the data breach may result to harm to data subjects.'
          break
        case 'request for exemption':
          tooltip = 'Request for exemption from data subject notification.'
          break
        case 'request for postponement':
          tooltip = 'Request for postponement of data subject notification, if it is not possible to notify the affected data subjects within 72 hours upon knowledge of or reasonable belief that the breach occurred.'
          break
        case 'request for extension':
          tooltip = 'Request for extension of time to file the Full Report, if it is not possible to file within five (5) days.'
          break
        case 'request for alternative means of notification':
          tooltip = 'Request for alternative means of notification to affected data subjects.'
          break
        default:
          tooltip = null
          break
      }
      return tooltip
    },
    toDateAndTime (date) {
      return dateAndTimeCreated(date)
    },
    addDays (date, days) {
      return addDaysToDate(date, days)
    },
    viewHistory () {
      this.dialog = true
    },
    scrollToTop () {
      this.$vuetify.goTo(0, 0)
    },
    convertDate (date) {
      return dateAndTimeCreated(date)
    },
    async getAdjudications () {
      const list = await crud('pbnef').list({ docketNumber: this.formItem.dbnNumber })
      if (list.entries && list.entries.length) {
        const recipients = list.entries.map(item => item.endorsedTo).filter(valid => valid)
        this.recipients = recipients
      }
    },
    showLogs () {
      this.$router.push({
        name: 'DataBreachActivityLogs',
        params: {
          dataTab: 'pdbnf',
          operation: 'view',
          id: this.formItem._id
        }
      })
    },
    async getNotificationsData () {
      const data = await this.notificationCrud.list({ advancedQuery: { type: { $eq: 'notificationType' } } })
      const filtered = data.entries.filter(x => x.type === 'notificationType')
      filtered.forEach((notif) => {
        const obj = {
          _id: notif._id,
          checkbox: false,
          subtype: undefined,
          remarks: '',
          subTotal: notif.subtype.length
        }
        this.formItem.notificationType.push(obj)
      })
      this.notifications = data.entries
    },
    populateNotificationType (notificationType) {
      notificationType && notificationType.forEach(notif => {
        const formNotif = this.formItem.notificationType.find(x => x._id === notif.value)
        if (formNotif) {
          formNotif.checkbox = true
          notif.subtype && (formNotif.subtype = notif.subtype)
          formNotif.remarks = notif.remarks
        }
      })
    },
    flattenObj (field, obj) {
      if (obj.details) {
        this.$set(this.formItem, field, obj.details)
      }
      if (obj.sufficientlyProvided) {
        this.$set(this.formItem, `${field}Provided`, obj.sufficientlyProvided)
      }
      if (obj.remarks) {
        this.$set(this.formItem, `${field}Remarks`, obj.remarks)
      }
    },
    async getUserData () {
      const currentUser = await this.$store.getters['lookups/getCurrentUser']
      this.$set(this.formItem, 'fullName', currentUser.organization)
      this.$set(this.formItem, 'email', currentUser.email)
      this.$set(this.formItem, 'sector', currentUser.sector)
      this.$set(this.formItem, 'subsector', currentUser.subsector)
      this.$set(this.formItem, 'pic', currentUser._id)
    },
    async populateUserData (entry) {
      this.$set(this.formItem, 'fullName', entry.pic.organization)
      this.$set(this.formItem, 'email', entry.pic.email)
      this.$set(this.formItem, 'sector', entry.pic.sector)
      this.$set(this.formItem, 'subsector', entry.pic.subsector)
      this.$set(this.formItem, 'enabled', entry.enabled)
      this.$set(this, 'evaluator', entry.assignedTo.evaluator._id)
      this.$set(this, 'reviewer', entry.assignedTo.firstPass._id)
      this.$set(this, 'finalReviewer', entry.assignedTo.final._id)
      this.$set(this.changeReqData, 'typeOfRequest', entry.typeOfRequest)
      this.$set(this.changeReqData, 'withRequest', entry.withRequest)
      this.$set(this.changeReqData, 'extensionDays', entry.extensionDays)
      this.$set(this.changeReqData, 'requestExtension', entry.requestExtension)
    },
    async getStatusList () {
      const data = await this.dbnStatusCrud.list(0, 100)
      this.dbnStatusList = data.entries
    },
    async getSectors () {
      const resp = await crud('sector').list({
        count: 100000
      })
      if (resp.ok) this.sectorOpts = resp.entries
    },
    async getCauses () {
      const resp = await crud('causeOfIncident').list({
        count: 100000
      })
      if (resp.ok) this.causeOpts = resp.entries
    },
    async getRecords () {
      const resp = await crud('recordType').list({
        count: 100000
      })
      if (resp.ok) this.recordOpts = resp.entries
    },
    capitalize,
    checkAction (tab) {
      return (this.startIndex <= tab) && (!this.saveIndex || tab <= this.saveIndex)
    },
    validateRefs () {
      Object.keys(this.$refs).forEach((ref) => {
        this.$refs[`${ref}`].$v && this.$refs[`${ref}`].$v.$touch()
      })
    },
    async getPriority () {
      if (!this.isAssignor) return
      const payload = { dataview: 'assignment', advancedQuery: { statusQuery: { $eq: 'submitted' } } }
      const data = await this.pdbnfCrud.list(payload)
      const items = data.entries
      this.isPriority = (items[0] && items[0]._id) === this.$route.params.id
    },
    getTypeOfRequestValue (item, index, value) {
      let label
      switch (item.label) {
        case 'Request for exemption':
          label = 'Request for exemption to notify data subject'
          break
        default:
          label = item.label
          break
      }
      return `${label}${index < value.length - 1 ? ',' : ''}`
    },
    showReminderModal () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return this.$store.dispatch('showAlert', {
          message: 'Please validate all the required fields.',
          type: 'error'
        })
      }
      this.$store.dispatch('showDialog', {
        title: 'Reminder',
        message: 'For updates and progress regarding this data breach, please wait for any communication from NPC. Do not submit a new PDBN for the submission of any update/new information.',
        buttonLabel: 'Ok',
        buttonColor: 'primary',
        removeCancel: true,
        titleClass: 'text-h4 font-weight-bold',
        messageClass: 'text-h6 font-weight-normal',
        buttonClass: 'text--darken-1 font-weight-bold text-h6',
        dialogWidth: 500,
        callback: () => this.confirmDialog(false, 'create')
      })
    },
    async confirmDialog (draft, action) {
      !draft && this.$v.$touch()
      !draft && this.validateRefs()
      const specifyOthersIsValid = this.$refs.dynamicFileInput ? this.$refs.dynamicFileInput.validate && this.$refs.dynamicFileInput.validate() : true
      if (action === 'upload' && !this.isDetailsProvided) {
        return this.triggerAlert({
          success: false,
          data: { message: 'Provide details on items tagged as "No" and "No Information yet".' }
        })
      }
      if ((!this.$v.$invalid && specifyOthersIsValid) || draft) {
        await this.$nextTick()
        if (!this.module.showConfirmDialog) return this.save()

        let message = `Are you sure you want to ${action === 'create' ? 'submit' : action} this form?`
        let title = `${this.capitalize(action === 'create' ? 'submit' : action)} PDBNF`
        let callback

        if (action === 'evaluate') {
          message = 'Are you sure you want to submit this form for review?'
          title = 'Submit DBN for Review'
        } else if (action === 'review') {
          const reviewType = this.status === 'Initial Review' ? 'Final Review' : 'Initial Order'
          message = `Are you sure you want to submit this form for ${reviewType}?`
          title = `Submit DBN for ${reviewType}`
        } else if (action === 'upload') {
          message = 'Are you sure you want to upload these documents?'
          title = 'Upload Documents'
        } else if (action === 'update') {
          message = 'You can save the changes and update it later.'
          title = 'Save as Draft'
        } else if (action === 'initiate' || action === 'resume') {
          message = 'Are you sure you want to submit this explanation?'
          title = 'Submit Explanation'
        } else if (action === 'change') {
          message = 'Are you sure you want to submit this form for Change of Request?'
          title = 'Submit Change of Request'
        }

        if (action === 'evaluate') {
          callback = () => { this.evaluate() }
        } else if (action === 'review') {
          callback = () => { this.review() }
        } else if (action === 'upload') {
          callback = () => { this.upload() }
        } else if (action === 'initiate' || action === 'resume') {
          callback = () => {
            this.showCauseDialog = false
            this.postShowCause(action)
          }
        } else if (action === 'change') {
          callback = () => { this.changeRequest() }
        } else {
          callback = () => { this.save(draft) }
        }

        let btnLabel = action
        if (action === 'create' || action === 'change' || action === 'evaluate') btnLabel = 'submit'
        else if (action === 'update') btnLabel = 'save'
        this.$store.dispatch('showDialog', {
          title,
          message,
          buttonLabel: btnLabel,
          buttonColor: action === 'update' ? 'primary' : 'success',
          callback
        })
      } else if (this.$v.$invalid && action === 'upload') {
        this.$store.dispatch('showAlert', {
          message: 'Upload of files cannot be blank.',
          type: 'error'
        })
      } else {
        this.$store.dispatch('showAlert', {
          message: 'Please validate all the required fields.',
          type: 'error'
        })
      }
    },
    customOptionFetch () {
      const populate = this.populateFetch ? 'populate=true' : ''
      if (!this.optionName || !this.optionName.length) return
      if (typeof this.optionName === 'object') {
        this.optionName.forEach((name) => {
          const typeOfQuery = this.customItems.userList.includes(name) ? 'advancedQuery' : 'queries'
          const query = this.optionQuery[`${name}`] || ''
          const req = {}
          this.optionQuery && (req.additionalQuery = this.optionQuery[`${name}`])
          this.optionView && (req.view = this.optionView[`${name}`])

          this.$store.dispatch(this.optionAction, {
            type: name,
            query: `?${populate}&${typeOfQuery}=${encodeURI(JSON.stringify(query))}`,
            nested: this.optionNested,
            req
          })
        })
      } else {
        const query = this.optionQuery || ''
        const typeOfQuery = this.customItems.userList.includes(this.optionName) ? 'advancedQuery' : 'queries'
        this.$store.dispatch(this.optionAction, {
          type: this.optionName,
          query: `?${populate}&${typeOfQuery}=${encodeURI(JSON.stringify(query))}`,
          nested: this.optionNested,
          id: this.optionID,
          req: { additionalQuery: query, view: this.optionView }
        })
      }
    },
    async save (draft) {
      !draft && this.$v.$touch()
      if (!this.$v.$invalid || draft) {
        this.readOnly = true
        if (this.operation === 'create') {
          await this.createItem(draft)
        } else {
          await this.updateItem(draft)
        }
      }
      this.loading = false
    },
    async evaluate () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.readOnly = true
        const { _id } = this.formItem
        const resp = await pdbnf.evaluate(_id, this.evaluateSchema)
        const data = await resp.json()
        this.triggerAlert({ success: resp.ok, action: 'evaluate', data })
      }
      this.loading = false
    },
    async review () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.readOnly = true
        const { _id } = this.formItem
        const body = this.evaluateSchema
        body.reviewStatus = this.status === 'Initial Review' ? 'Final Review' : 'Initial Order'
        const resp = await pdbnf.review(_id, this.evaluateSchema)
        const data = await resp.json()
        this.triggerAlert({ success: resp.ok, action: 'reviewe', data })
      }
      this.loading = false
    },
    async upload () {
      this.loading = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.readOnly = true
        const keys = Object.keys(this.form.formParams.fields)
        await keys.reduce(async (previousPromise, key) => {
          return previousPromise.then(() => {
            return this.uploadFile(key)
          })
        }, Promise.resolve())

        const body = this.initialOrderSchema
        body.status = this.dbnStatusList.find(x => x.value === 'For Evaluation - FBNER')._id
        const resp = await this.collection.update(this.id, body)
        const data = await resp.json()
        this.triggerAlert({ success: resp.ok, action: 'upload', data })
      }
      this.loading = false
    },
    async changeRequest () {
      const { _id } = this.formItem
      const resp = await crud('changeRequest/pdbnf').update(_id, this.schema)
      const data = await resp.json()
      this.triggerAlert({ success: resp.ok, action: 'change', data })
    },
    async getImage (id, file, query) {
      if (!file) return ''
      const getFile = []
      for (let i = 0; i < file.length; i++) {
        const { filename, mimetype } = file[`${i}`]
        const data = await this.collection.getImage(id, filename, query)
        getFile.push(await dataURLToFile(data.file, filename, mimetype))
      }
      return getFile
    },
    async uploadFile (key) {
      const dataForm = new FormData()
      const files = this.form.formParams.fields
      if (Array.isArray(files[`${key}`])) {
        files[`${key}`].forEach((entry) => {
          dataForm.append(key, entry)
        })
      } else {
        dataForm.append(key, files[`${key}`])
      }
      return await crud('attachment/pdbnf').createForm(
        dataForm,
        this.form.formParams.query,
        this.id,
        key
      )
    },
    async uploadClick (fieldName, inputFile) {
      const form = new FormData()
      if (Array.isArray(inputFile)) {
        inputFile.forEach((entry) => {
          form.append(fieldName, entry)
        })
      } else {
        form.append(fieldName, inputFile)
      }
      return await crud('attachment/pdbnf').createForm(
        form,
        {},
        this.id,
        fieldName
      )
    },
    async view () {
      this.$v.$reset()
      let dataview = ''
      if (this.form.dataView) {
        dataview = this.form.dataView
      }
      const data = await this.collection.read(this.id, dataview)
      this.picUser = data.entry.pic
      this.populateUserData(data.entry)
      const keys = Object.keys(data.entry)
      await keys.forEach((field) => {
        if (field === 'pic') {
          this.$set(this.formItem, 'pic', data.entry.pic._id)
        } else if (field === 'notificationType') {
          data.entry.notificationType && this.populateNotificationType(data.entry.notificationType)
        } else if (this.objToFlat.includes(field) && data.entry[`${field}`]) {
          this.flattenObj(field, data.entry[`${field}`])
        } else if (this.dateFields.includes(field) && data.entry[`${field}`]) {
          this.$set(this.formItem, field, format(new Date(data.entry[`${field}`]), 'yyyy-MM-dd'))
        } else if (this.fileFields.includes(field) && data.entry[`${field}`]) {
          this.$set(this.formItem, `${field}File`, data.entry[`${field}`])
        } else if (field === 'others') {
          const value = data.entry[`${field}`]
          const othersValue = typeof value === 'string' ? [value] : value
          this.$set(this.formItem, field, othersValue)
        } else if (field === 'enabled') {
          const enabledKeys = Object.keys(data.entry.enabled)
          enabledKeys.forEach(x => {
            this.$set(this.formItem, `${x}Checkbox`, data.entry.enabled[`${x}`])
          })
        } else {
          this.$set(this.formItem, field, data.entry[`${field}`])
        }
      })
      this.status = this.formItem.status.value
      this.formItem.atLeastOneHundredIndividuals = this.formItem.numberOfDataSubjectsAffected >= 100
      if (this.isFBNER || this.status === 'For Adjudication' || this.status === 'For Investigation' || this.status === 'For Enforcement' || this.status === 'Closed') this.getFbner()
    },
    async getFbner () {
      const dataview = 'picView'
      const list = await crud('fbner').list({ dataview, advancedQuery: { 'pdbnf._id': this.id } })
      const entry = list.entries[0]
      if (entry) {
        this.$set(this, 'fbnerId', entry._id)
        this.$set(this, 'submittedFbner', entry.isSubmitted)
        this.$set(this, 'currentRecipient', entry.endorserId)
        this.$set(this, 'assignedAdjudicator', entry.recipient && entry.recipient.adjudication)
        this.$set(this, 'assignedInvestigator', entry.recipient && entry.recipient.investigation)
        this.$set(this, 'assignedEnforcer', entry.recipient && entry.recipient.enforcement)
      }
    },
    goToFbner () {
      this.$router.push({
        name: 'FinalBreachEvaluationView',
        params: {
          role: this.formItem.status.value === 'For Evaluation - FBNER' ? 'default' : 'evaluate',
          operation: 'view',
          id: this.fbnerId && this.submittedFbner ? this.fbnerId : this.id
        }
      })
    },
    async generatePDF () {
      window.scroll(0, 0)
      this.exportData = this.formItem
      this.exportData.notifications = this.defineNotifications()
      this.exportData.sectorOpts = this.sectorOpts
      this.exportData.causeOpts = this.causeOpts
      this.exportData.recordOpts = this.recordOpts
      const element = this.$el.querySelector('#pdfContent')
      return this.viewPDF(element, this.formItem.dbnNumber)
    },
    defineNotifications () {
      return this.formItem.notificationType.map((notif) => {
        if (notif.checkbox) {
          const info = this.notifications.find(x => x._id === notif._id)
          const sub = info.subtype.find(y => y._id === notif.subtype)
          if (!info) return
          return {
            ...notif,
            name: info ? info.value : notif._id,
            subtype: sub ? sub.value : notif.subtype
          }
        }
      })
    },
    async createItem (draft) {
      this.loading = true

      let status
      draft && (status = this.dbnStatusList.find(x => x.value === 'Drafted'))
      !draft && (status = this.dbnStatusList.find(x => x.value === 'Submitted'))
      this.$set(this.formItem, 'status', status._id)
      let resp
      this.objectId && convertObjId(this.objectId, this.schema)
      Object.keys(this.schema).forEach(key => !this.schema[`${key}`] && delete this.schema[`${key}`])

      const dataForm = await uploadNestedForm(this.schema, this.nestedSchema)
      if (this.uploadQuery) {
        resp = await this.collection.createForm(dataForm, this.uploadQuery)
      } else {
        resp = await this.collection.create(this.schema)
      }
      const data = await resp.json()
      const action = draft ? 'update' : 'create'
      this.triggerAlert({ success: resp.ok, action, data })
    },
    async postShowCause (action) {
      const status = action === 'initiate' ? 'For Evaluation - FBNER' : 'Initial Order'
      const dbnStatus = this.dbnStatusList.find(x => x.value === status)
      const resp = await crud(`assign/${this.dataTab}/statusUpdate`).update(this.id, {
        status: dbnStatus._id,
        showCauseReason: this.showCauseReason
      })
      const data = await resp.json()
      this.triggerAlert({ success: resp.ok, action, data })
      await this.view()
    },
    async updateItem (draft) {
      this.loading = true
      let status
      draft && (status = this.dbnStatusList.find(x => x.value === 'Drafted'))
      !draft && (status = this.dbnStatusList.find(x => x.value === 'Submitted'))
      this.$set(this.formItem, 'status', status._id)

      const { _id } = this.formItem
      let resp
      this.objectId && convertObjId(this.objectId, this.schema)
      const dataForm = await uploadNestedForm(this.schema, this.nestedSchema)
      if (this.uploadQuery) {
        resp = await this.collection.updateForm(dataForm, this.uploadQuery, _id)
      } else {
        resp = await this.collection.update(_id, this.schema)
      }
      const data = await resp.json()
      const action = draft ? 'update' : 'create'
      this.triggerAlert({ success: resp.ok, action, data })
    },
    async deleteItem () {
      this.loading = true
      const resp = await this.collection.delete(this.id)
      if (resp.ok) {
        this.$store.dispatch('showAlert', {
          message: 'PDBNF Draft has been successfully deleted!',
          type: 'delete'
        })
        this.$router.push(this.backRoute)
      } else {
        this.$store.dispatch('showAlert', {
          message: (await resp.json()).error,
          type: 'error'
        })
      }
      this.loading = false
    },
    async run (fn, callback) {
      const { _id } = this.formItem
      await this.collection.run(fn)(_id)()
      const data = await this.collection.read(_id)
      this.$set(this, 'formItem', data)
    },
    checkDelete () {
      this.$store.dispatch('showDialog', {
        title: 'Delete PDBNF Draft',
        message: 'Do you want to delete this form? This action cannot be undone.',
        buttonLabel: 'Delete',
        callback: () => { this.deleteItem() }
      })
    },
    triggerAlert ({ success, action, data }) {
      if (success) {
        let type = 'success'
        let message = `Your Personal Data Breach Notification Form has been successfully ${action === 'create' ? 'submitte' : action}d!`
        if (action === 'upload') {
          message = 'You have successfully shared all the documents for PDBNF'
        } else if (action === 'evaluate') {
          const dbnNo = this.formItem.dbnNumber.replace('NPC BN', 'DBN')
          message = `You have successfully ${action}d ${dbnNo}`
        } else if ((data.entry || data.updatedResult).statusQuery === 'drafted') {
          message = 'Your Personal Data Breach Notification Form has been successfully saved as draft!'
          type = 'draft'
        } else if (action === 'update') {
          message = 'Your Personal Data Breach Notification Form has been successfully submitted!'
        } else if (action === 'initiate') {
          message = 'This Personal Data Breach Notification Form has been successfully initiated for FBNER'
        } else if (action === 'resume') {
          message = 'Document sharing has been resumed for this Personal Data Breach Notification Form'
        } else if (action === 'change') {
          message = 'You have successfully changed the request for PDBNF.'
        }

        if (action === 'create') {
          const id = (data.entry && data.entry._id) || this.$route.params.id
          socket.emit('create notifications', {
            message: `A Personal Data Breach Notification Form has been submitted by ${this.profile.firstName} ${this.profile.lastName} and is now ready for assignment.`,
            collectionName: 'DataBreachTableAssign',
            collectionId: id,
            userIds: [],
            roleRecipients: 'assignor'
          })
        }

        this.$store.dispatch('showAlert', {
          message,
          type: type
        })
        if (!(action === 'view' || action === 'resume' || action === 'initiate')) {
          this.$router.push({
            name: this.createReroute,
            params: {
              dataTab: this.dataTab,
              operation: 'view',
              id: (data.entry || data.updatedResult)._id
            }
          })
        }
        this.readOnly = true
      } else {
        this.$store.dispatch('showAlert', {
          message: data.error || data.message,
          type: 'error'
        })
        this.readOnly = false
      }
    },
    tabFields (tabId) {
      return this.flatFields.reduce((item, curr) => [...item, (curr.formKey && curr.formKey)], [])
    },
    validate () {
      this.tabFields(this.activeTab).forEach((f) => {
        if (this.$v.formItem[`${f}`]) this.$v.formItem[`${f}`].$touch()
      })
    },
    isInvalid () {
      const tabInvalid = []
      this.tabFields(this.activeTab).forEach((f) => {
        if (this.$v.formItem[`${f}`]) tabInvalid.push(this.$v.formItem[`${f}`].$invalid)
      })
      return tabInvalid.includes(true)
    },
    prevTab: function () {
      this.$data.activeTab = this.$data.activeTab === 1
        ? 1 : this.$data.activeTab - 1

      this.$data.forSubmission = false
    },
    nextTab: function () {
      const length = this.tabs.length
      this.activeTab = this.activeTab === length ? length : this.activeTab + 1
      this.$data.forSubmission = this.isLastTab
    },
    async autofillFunction (autofillURL) {
      const url = `${autofillURL}${this.formItem.student}`
      const res = await this.collection.autofill(url)
      const keys = Object.keys(res.entry)
      await keys.forEach((field) => {
        this.$set(this.formItem, field, res.entry[`${field}`])
      })
    }
  },
  validations () {
    if (!this.isPic) return { formItem: this.formValidations, ...custom.assignStatus }
    return {
      formItem: this.formValidations
    }
  }
}
</script>

<style scoped>
  .v-stepper{
    box-shadow: none;
  }
  .transparent-bg {
    background-color: rgba(0,0,0,0);
  }
  .cursor >>>  textarea{
    overflow-y: hidden !important;
    cursor: default !important
  }
  .v-btn {
    text-transform: none;
  }
  .highlight >>> fieldset {
    background-color: pink
  }
  .showCauseText{
  color: #aaa;
  text-align: center;
  margin-top: .75rem;
  }
  .showCauseBtn{
    font-size: 5rem;
  }
  .showCauseOption:hover > .showCauseText, .showCauseOption:hover > .showCauseBtn{
  color:#272a68;
  }
  .showCauseOption:hover{
    cursor: pointer;
  }
  .color-transparent >>> textarea {
    color: transparent !important
  }
  .color-transparent >>> input {
    color: transparent !important
  }

</style>
